import store from '@/store'
import { refundStatusHistory } from '@/config'
import commonUtil from '@/util/commonUtil'

export default {
  getRefundStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      refundStatusHistory.STATUS,
      refundStatusHistory.STATUS_HISTORY_LABEL
    )
  },

  getRefundStatusName(status) {
    switch (status) {
      case 1:
        return '登録'
      case 99:
        return '無効'
      default:
        return '-'
    }
  }
}
